export const focusSelector = 'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex], [contenteditable="true"], summary';

export const isVisible = (element) => {
    if (!element?.isConnected || element.closest('[hidden], [inert]')) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
};

export const focusableElements = (roots) => {
    const result = roots.flatMap((root) => Array.from(root.querySelectorAll(focusSelector)));
    return [...new Set(result)].filter((element) => element.tabIndex >= 0 && !element.matches(':disabled') && isVisible(element));
};

export const tabBoundary = (elements, active, backwards) => {
    if (!elements.length) return null;
    if (!elements.includes(active)) return backwards ? elements.at(-1) : elements[0];
    if (backwards && active === elements[0]) return elements.at(-1);
    if (!backwards && active === elements.at(-1)) return elements[0];
    return null;
};

export const isolateOutside = (roots, parent = document.body) => {
    const changed = [];
    const visit = (node) => {
        Array.from(node.children).forEach((child) => {
            if (roots.includes(child) || child.matches('script, style, link')) return;
            if (roots.some((root) => child.contains(root))) {
                visit(child);
            } else if (!child.inert) {
                child.inert = true;
                changed.push(child);
            }
        });
    };
    visit(parent);
    return () => changed.forEach((element) => { element.inert = false; });
};

export const focusColorForBackground = (background) => {
    const luminance = (rgb) => rgb.map((value) => {
        const channel = value / 255;
        return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
    }).reduce((sum, value, index) => sum + value * [0.2126, 0.7152, 0.0722][index], 0);
    const light = luminance(background);
    const contrast = (rgb) => {
        const other = luminance(rgb);
        return (Math.max(light, other) + 0.05) / (Math.min(light, other) + 0.05);
    };
    const darkRatio = contrast([3, 18, 22]);
    const blueRatio = contrast([0, 162, 212]);
    return blueRatio >= 3 && light < 0.22 ? 'var(--site-focus-light)' :
        darkRatio >= 3 ? 'var(--site-focus-dark)' : 'var(--site-focus-light)';
};
